export default __webpack_public_path__ + "static/media/calendar_meeting_builder.7176532e.svg";